/** SA-1034 PR 5 (spec §3.3): the Conversations page's RAG badge, worded by `ragStatusText`. */
import { Badge, Tip } from '@/components/ui'
import { useAppStore } from '@/stores/appStore'
import { ragStatusWords } from './ragStatusText'

export function RagStatusBadge() {
  const status = useAppStore((s) => s.ragConnectionStatus)
  const words = ragStatusWords(status)
  return (
    <Tip text={words.tip}>
      <Badge variant={words.tone} tabIndex={0} data-testid="rag-status">{words.label}</Badge>
    </Tip>
  )
}
